/*
 * @Description: 
 * @Date: 2025-06-23 14:28:46
 * @LastEditors: function
 * @LastEditTime: 2025-07-11 14:52:02
 * @FilePath: \protal-web\src\config\vuex\stroe.js
 */
import Vue from "vue";
import Vuex from "vuex";
import { getContact } from "@/api/contact";
import { getUserInfo } from "@/api/home";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    count: 0,
    contact: {},
    userInfo: {},
  },
  mutations: {
    _setContact(state, data) {
      state.contact = data;
    },
    _setUserInfo(state, data) {
      state.userInfo = data;
    },
  },
  actions: {
    InitContact(context) {
      getContact().then((res) => {
        context.commit("_setContact", res.data);
      });
    },
    ActionUserInfo(context) {
      getUserInfo().then((res) => {
        context.commit("_setUserInfo", res.data);
      });
    },
  },
});
